<template>
  <div>
    <transition name="slide-in-down" appear appear-active-class="animated slideInDown">
      <v-toolbar style="padding: 0px" :clipped-left="!$vuetify.rtl" :clipped-right="!$vuetify.rtl" app fixed>
        <v-tooltip bottom v-if="$route.name !== 'home'">
          <v-toolbar-side-icon slot="activator" @click.stop="$emit('click')"></v-toolbar-side-icon>
          <span v-if="!drawer">{{ $t('Show Sidebar') }}</span>
          <span v-if="drawer">{{ $t('Hide Sidebar') }}</span>
        </v-tooltip>
        <v-toolbar-title icon>
          <v-icon class="no-select" style="font-size:25px; color:rgb(10, 60, 100);">{{ appBar.icon }}</v-icon>
        </v-toolbar-title>
        <v-toolbar-title>
          <span v-html="appBar.title" style="text-transform: uppercase;"></span>
        </v-toolbar-title>
        <v-spacer />

        <v-layout justify-end>
          <v-toolbar-title
            style="margin-top: auto; margin-bottom: auto; text-shadow: 0px 1px 1px black;"
            class="deep-purple--text text--darken-4"
            ><em>{{ user_outlet }}</em></v-toolbar-title
          >
          <v-menu v-if="appsPermission()" min-width="350px" offset-y bottom transition="slide-y-reverse-transition">
            <template v-slot:activator="{ on }">
              <v-btn fab flat v-on="on">
                <v-icon>apps</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-layout row wrap pa-4>
                <v-flex
                  xs4
                  py-2
                  v-for="(item, index) in appsItems.filter(item => hasPermissions(item.permission))"
                  :key="index"
                  style="text-align: center"
                >
                  <div style="cursor: pointer" ripple @click="onMenuClick(item.id)">
                    <v-icon style="padding-left: 10px" size="35">{{ item.icon }}</v-icon>
                    <br />
                    <span class="grey--text text--darken-3">
                      {{ item.title }}
                    </span>
                  </div>
                </v-flex>
              </v-layout>
            </v-list>
          </v-menu>

          <v-menu offset-y bottom transition="slide-y-reverse-transition">
            <template v-slot:activator="{ on }">
              <v-tooltip :left="!$vuetify.rtl" :right="$vuetify.rtl">
                <v-avatar
                  slot="activator"
                  style="cursor: pointer"
                  :class="{
                    profileWithApp: appsPermission(),
                    profileWithoutApp: !appsPermission() && !$vuetify.rtl,
                    profileWithoutAppRtl: !appsPermission() && $vuetify.rtl
                  }"
                  :size="30"
                >
                  <img
                    v-on="on"
                    :src="
                      getAuthUserData.user_image_path
                        ? `${baseUrls.images}/${getAuthUserData.user_image_path}`
                        : getAuthUserData.user_gender === 'Female'
                        ? `${baseUrls.images}/profile-female.png`
                        : `${baseUrls.images}/profile-male.png`
                    "
                  />
                </v-avatar>
                <span>{{ getAuthUserData.user_full_name ? getAuthUserData.user_full_name.split(' ')[0] : '' }}</span>
              </v-tooltip>
            </template>
            <v-list>
              <router-link to="/profile" style="text-decoration: none">
                <v-list-tile>
                  <v-icon>fa-user</v-icon>
                  <v-list-tile-content>
                    <v-list-tile-title class="px-3">
                      <strong class="grey--text text--darken-3">
                        {{ $t('Profile') }}
                      </strong>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </router-link>

              <v-list-tile @click="logout()">
                <v-icon v-if="$vuetify.rtl" style="transform: rotate(180deg);" color="red">fa-sign-out-alt</v-icon>
                <v-icon v-if="!$vuetify.rtl" color="red">fa-sign-out-alt</v-icon>
                <v-list-tile-content>
                  <v-list-tile-title class="px-3">
                    <strong class="grey--text text--darken-3">
                      {{ $t('Logout') }}
                    </strong>
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-layout>
      </v-toolbar>
    </transition>
    <view-all-balance :viewDialog="dialogs.allBalanceDialog" @hidemodal="dialogs.allBalanceDialog = false" />
    <balance-component :viewDialog="dialogs.balanceDialog" @hidemodal="dialogs.balanceDialog = false" />
    <dollar-component :addDialog="dialogs.dollarDialog" @hidemodal="dialogs.dollarDialog = false" />
    <exchange-component :addDialog="dialogs.exchangeDialog" @hidemodal="dialogs.exchangeDialog = false" />
  </div>
</template>

<script>
/* global swal */

import { mapGetters, mapActions } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'

export default {
  name: 'Topbar',

  components: {
    viewAllBalance: () => import('./viewAllBalance.vue'),
    balanceComponent: () => import('./viewBalance.vue'),
    dollarComponent: () => import('@/views/accounting/dollarRates/addDollarRate.vue'),
    exchangeComponent: () => import('@/views/accounting/currencyExchanges/addCurrencyExchange.vue')
  },

  props: {
    drawer: {
      type: Boolean,
      default: false,
      required: false
    }
  },

  data() {
    return {
      dialogs: {
        allBalanceDialog: false,
        balanceDialog: false,
        dollarDialog: false,
        exchangeDialog: false
      },
      userProfileImage: false,
      user_name: '',
      placeHolderImage: '',
      user_outlet: '',
      appsItems: [
        {
          id: 0,
          title: `${this.$t('All Balance')}`,
          icon: 'account_balance_wallet',
          permission: ['cash_balance_show']
        },
        {
          id: 1,
          title: `${this.$t('Balance')}`,
          icon: 'account_balance_wallet',
          permission: ['cash_balance_show', 'show_cashier_balance']
        },
        {
          id: 2,
          title: `${this.$t('Dollar Rate')}`,
          icon: 'monetization_on',
          permission: ['dollar_prices_store']
        },
        {
          id: 3,
          title: `${this.$t('Exchange')}`,
          icon: 'fa-hand-holding-usd',
          permission: ['currency_exchange_store']
        }
      ]
    }
  },

  mounted() {
    this.setAuthUserData(this.$auth.user())
    this.notify(this.$auth.user().user_full_name)
    this.user_outlet = this.getAuthUserData.current_outlet
  },

  computed: {
    ...mapGetters({
      getAuthUserData: 'auth/getAuthUserData',
      authToken: 'auth/getAuthToken',
      displayGreeting: 'misc/getDisplayGreeting',
      appBar: 'dashboard/getAppBarTitle',
      baseUrls: 'misc/getBaseUrls'
    })
  },

  methods: {
    ...mapActions({
      setAuthUserData: 'auth/setAuthUserData',
      resetAuthUserData: 'auth/resetAuthUserData',
      setDisplayGreeting: 'misc/setDisplayGreeting',
      fetchInfo: 'dashboard/fetchCashBalance',
      fetchAllBalance: 'dashboard/fetchAllBalance'
    }),

    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    },

    appsPermission() {
      return this.hasPermissions([
        'cash_balance_show',
        'show_cashier_balance',
        'dollar_prices_store',
        'currency_exchange_store'
      ])
    },

    onMenuClick(id) {
      switch (id) {
        case 0:
          this.viewAllBalance()
          break
        case 1:
          this.viewBalance()
          break
        case 2:
          this.dialogs.dollarDialog = true
          break
        case 3:
          this.dialogs.exchangeDialog = true
          break
      }
    },

    viewAllBalance() {
      this.fetchAllBalance().then(() => {
        this.dialogs.allBalanceDialog = true
      })
    },

    viewBalance() {
      this.fetchInfo().then(() => {
        this.dialogs.balanceDialog = true
      })
    },

    logout() {
      swal({
        title: this.$t('Are you sure you want to logout?'),
        text: this.$t('All unsaved data will be omitted'),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(confirmLogout => {
        if (confirmLogout) {
          this.$auth.logout()
          this.resetAuthUserData()
          this.setDisplayGreeting(true)
        }
      })
    },

    notify(name = '') {
      if (name === '' || !this.displayGreeting) {
        return false
      }
      // When switching UI direction, notification will only change position after full page reload!!
      setTimeout(() => {
        helpers.ktNotify({
          // time in milliseconds, if not a number or not provided default is 3000 (ms)
          time: 1000,
          // type options: success, info, error, default is notice "yellow"
          type: 'success',
          text: `${this.$t('Welcome')} <strong>${name}</strong>`
        })
      }, 1500)
      this.setDisplayGreeting(false)
    }
  }
}
</script>

<style scoped>
.v-toolbar {
  position: fixed;
  top: 0;
  z-index: 999;
}

.profileWithoutApp {
  margin-left: 16px;
}

.profileWithoutAppRtl {
  margin-right: 16px;
}

.profileWithApp {
  margin-top: 19px;
}
</style>
